import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont/iconfont.js";
import "@/utils/components.js";
import "@/styles/index.scss";
import { getVueBaseApi } from '@/utils/index'
Vue.prototype.getVueBaseApi = getVueBaseApi


Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
store.commit("setIsKf", window.location.origin.includes("http://localhost"));
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
